// import AssetManagerContainer from asset-manager-container.js
import { AssetManagerContainer } from "./custom-elements/asset-manager-container.js";
// import AssetManagerMapLayer from asset-manager-map-layer.js
import { AssetManagerMapLayer } from "./custom-elements/asset-manager-map-layer.js";
// import AssetManagerSketchableMapLayer from asset-manager-sketchable-map-layer.js
import { AssetManagerSketchableMapLayer } from "./custom-elements/asset-manager-sketchable-map-layer.js";
// import AssetManagerMapLayerDataDisplay from asset-manager-map-layer-data-display.js
import { AssetManagerMapLayerDataDisplay } from "./custom-elements/asset-manager-map-layer-data-display.js";
// import AssetManagerModeToggle from asset-manager-mode-toggle.js
import { AssetManagerModeToggle } from "./custom-elements/asset-manager-mode-toggle.js";
// import from asset-manager-functions.js
import { captureMapLayers } from "./utils/asset-manager-functions.js";
// import from asset-manager-sketchable-map-layer-functions.js
import { captureSketachableMapLayers } from "./utils/asset-manager-sketchable-map-layer-functions.js";
// import initializeMap function from map-initialization.js
import { initializeMap } from "./utils/asset-manager-initialize-map.js";
// capture the map layers added to the asset-manager-container component
captureMapLayers();
// capture the sketchable map layers added to the asset-manager-container component
captureSketachableMapLayers();
// initialize the map after the DOM content has loaded and the MapLayer and AssetManagerContainer components are defined
document.addEventListener("DOMContentLoaded", () => {
  customElements.define("asset-manager-mode-toggle", AssetManagerModeToggle);
  customElements.define("asset-manager-map-layer", AssetManagerMapLayer);
  customElements.define(
    "asset-manager-sketchable-map-layer",
    AssetManagerSketchableMapLayer,
  );
  customElements.define(
    "asset-manager-map-layer-data-display",
    AssetManagerMapLayerDataDisplay,
  );
  customElements.define("asset-manager-container", AssetManagerContainer);
  // Wait for the AssetManagerContainer to be defined and rendered before initializing the map
  customElements.whenDefined("asset-manager-container").then(() => {
    function waitForElement(selector, callback) {
      const el = document.querySelector(selector);
      if (el) {
        callback(el);
      } else {
        setTimeout(() => waitForElement(selector, callback), 100);
      }
    }
    waitForElement("#viewDiv", () => {
      initializeMap();
    });
  });
});
